export const MOBILE_WIDTH = 640;